import { collectMenuSubtreeIds, findMenuNodeInTree, findMenuParentChain, menuHasNavChildren } from './menuNavTree'
import { TRIAL_FEATURE_REGISTRY } from '../constants/trialFeatureRegistry'

function normalizeMenuId (menuId) {
  if (menuId == null || menuId === '') return ''
  return String(menuId)
}

const PHASE_RANK = {
  TRIAL_EXPIRED: 3,
  TRIAL_EXPIRING: 2,
  TRIAL_ACTIVE: 1,
  PAID_ACTIVE: 0
}

function phaseRank (phase) {
  return PHASE_RANK[phase] || 0
}

function indexFeatures (features) {
  const byKey = {}
  ;(features || []).forEach(function (f) {
    if (!f || !f.phase) return
    if (f.featureKey) byKey[String(f.featureKey)] = f
    if (f.skuCode) byKey[String(f.skuCode)] = f
  })
  return byKey
}

function upsertMark (out, menuId, feature) {
  if (menuId == null || menuId === '' || !feature || !feature.phase) return
  const id = normalizeMenuId(menuId)
  const cur = out[id]
  if (!cur || phaseRank(feature.phase) > phaseRank(cur.phase)) {
    out[id] = feature
  }
}

function collectMenuIdsByEnNames (nodes, enNames, out) {
  const want = new Set((enNames || []).map(function (n) { return String(n).trim() }).filter(Boolean))
  if (!want.size || !Array.isArray(nodes)) return out || []
  const ids = out || []
  const walk = (list) => {
    ;(list || []).forEach(function (node) {
      if (!node) return
      const en = String(node.enName || node.en_name || '').trim()
      if (want.has(en)) ids.push(node.id)
      if (Array.isArray(node.menuList) && node.menuList.length) walk(node.menuList)
    })
  }
  walk(nodes)
  return ids
}

function applyTrialMarkAnchor (out, list, menuId, feature, options) {
  upsertMark(out, menuId, feature)
  const chain = findMenuParentChain(list, menuId) || []
  chain.forEach(function (node) {
    upsertMark(out, node.id, feature)
  })
  if (options && options.inheritDescendants === false) return
  const anchor = findMenuNodeInTree(list, menuId)
  if (anchor && menuHasNavChildren(anchor)) {
    collectMenuSubtreeIds(anchor).forEach(function (descId) {
      upsertMark(out, descId, feature)
    })
  }
}

/** menuId → 试用态（含子项试用时祖先链继承，取最严重 phase） */
export function buildMenuTrialMarkMap (menuList, features) {
  const out = {}
  const byKey = indexFeatures(features)
  const list = menuList || []

  Object.keys(TRIAL_FEATURE_REGISTRY).forEach(function (key) {
    const reg = TRIAL_FEATURE_REGISTRY[key]
    const feature = byKey[key] || byKey[reg.skuCode]
    if (!feature || !feature.phase) return
    const anchorIds = []
    ;(reg.menuIds || []).forEach(function (id) { anchorIds.push(id) })
    collectMenuIdsByEnNames(list, reg.menuEnNames, anchorIds).forEach(function (id) {
      anchorIds.push(id)
    })
    const seen = new Set()
    anchorIds.forEach(function (menuId) {
      const norm = normalizeMenuId(menuId)
      if (!norm || seen.has(norm)) return
      seen.add(norm)
      applyTrialMarkAnchor(out, list, menuId, feature, {
        inheritDescendants: reg.inheritDescendants !== false
      })
    })
  })

  return out
}

export function resolveMenuTrialMark (menuList, features, menuId) {
  if (menuId == null || menuId === '') return null
  const map = buildMenuTrialMarkMap(menuList, features)
  return map[normalizeMenuId(menuId)] || null
}



// WEBPACK FOOTER //
// ./src/utils/trialSidebarMarks.js